import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'
import Group from 'components/utils/Group'
import React from 'react'

function LoadingMultiRoomGroupButtonsSkeleton() {
  return (
    <Group direction="horizontal" gap={8} horizontalAlign="start">
      <TextLoadingBox typography="heading3" width="6ch" />
      <TextLoadingBox typography="heading3" width="5ch" />
    </Group>
  )
}

export default LoadingMultiRoomGroupButtonsSkeleton
